import { render, staticRenderFns } from "./ProfileMenuForm.vue?vue&type=template&id=42beecf3"
import script from "./ProfileMenuForm.vue?vue&type=script&lang=js"
export * from "./ProfileMenuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports